const MAIN_DOMAIN = process.env.REACT_APP_MAIN_DOMAIN || 'zakazuj.com';
const LOCALHOST_SUFFIX = process.env.REACT_APP_LOCAL_SUBDOMAIN_SUFFIX || '.localhost';

const isBrowser = typeof window !== 'undefined';

const sanitizeSegment = (segment) => {
  if (!segment) return null;
  const clean = segment.trim().toLowerCase();
  if (!clean || clean === 'www') return null;
  return clean;
};

export const getTenantSubdomain = () => {
  if (!isBrowser) return null;

  const hostname = window.location.hostname?.toLowerCase();
  if (!hostname) return null;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null;
  }

  // Handle localhost with suffix (e.g., tenant.test.localhost or tenant.localhost)
  if (hostname.endsWith(LOCALHOST_SUFFIX)) {
    const withoutSuffix = hostname.slice(0, hostname.length - LOCALHOST_SUFFIX.length);
    const parts = withoutSuffix.split('.');
    
    // If there's a "test" segment, skip it and look for tenant
    const testIndex = parts.indexOf('test');
    if (testIndex !== -1) {
      // If "test" is the only part, treat as main domain
      if (parts.length === 1) {
        return null;
      }
      // If "test" is first, use second part as tenant
      if (testIndex === 0 && parts.length > 1) {
        return sanitizeSegment(parts[1]);
      }
      // If "test" is second, use first part as tenant
      if (testIndex === 1 && parts.length > 1) {
        return sanitizeSegment(parts[0]);
      }
    }
    // Otherwise, use first part as tenant
    return sanitizeSegment(parts[0]);
  }

  // Handle main domain
  if (hostname === MAIN_DOMAIN) {
    return null;
  }

  // Handle subdomains with main domain (e.g., tenant.zakazuj.com or tenant.test.zakazuj.com)
  if (hostname.endsWith(`.${MAIN_DOMAIN}`)) {
    const withoutMainDomain = hostname.slice(0, hostname.length - (MAIN_DOMAIN.length + 1));
    const parts = withoutMainDomain.split('.');
    
    // If there's a "test" segment, skip it and look for tenant
    const testIndex = parts.indexOf('test');
    if (testIndex !== -1) {
      // If "test" is the only part, treat as main domain
      if (parts.length === 1) {
        return null;
      }
      // If "test" is first, use second part as tenant
      if (testIndex === 0 && parts.length > 1) {
        return sanitizeSegment(parts[1]);
      }
      // If "test" is second, use first part as tenant
      if (testIndex === 1 && parts.length > 1) {
        return sanitizeSegment(parts[0]);
      }
    }
    // Otherwise, use first part as tenant
    return sanitizeSegment(parts[0]);
  }

  // Fallback for other domains (e.g., tenant.domain.tld or tenant.test.domain.tld)
  const parts = hostname.split('.');
  if (parts.length > 2) {
    // If there's a "test" segment, skip it and look for tenant
    const testIndex = parts.indexOf('test');
    if (testIndex !== -1) {
      // If "test" is the only subdomain part (e.g., test.domain.tld), treat as main domain
      if (testIndex === 0 && parts.length === 3) {
        return null;
      }
      // If "test" is first subdomain, use second as tenant (e.g., tenant.test.domain.tld)
      if (testIndex === 0 && parts.length > 3) {
        return sanitizeSegment(parts[1]);
      }
      // If "test" is second subdomain, use first as tenant (e.g., tenant.test.domain.tld)
      if (testIndex === 1 && parts.length > 3) {
        return sanitizeSegment(parts[0]);
      }
    }
    // Otherwise, use first part as tenant
    return sanitizeSegment(parts[0]);
  }

  return null;
};

export const isTenantSubdomainMode = () => !!getTenantSubdomain();

const subdomainUtils = {
  getTenantSubdomain,
  isTenantSubdomainMode,
};

export default subdomainUtils;

